import { usePageMeta } from '../lib/meta';
import { CONTACT_EMAIL } from '../config';

const EFFECTIVE_DATE = 'July 18, 2026';

export function TermsPage() {
  usePageMeta({
    title: 'Terms of Use',
    description:
      'Terms of Use for PeacockOmlettes.com, including the humor disclaimer, food-safety notice, and limitations of liability.',
    path: '/terms',
  });

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
      <h1 className="font-display text-3xl text-plume-950 sm:text-5xl">Terms of Use</h1>
      <p className="mt-3 text-sm text-plume-600">Effective date: {EFFECTIVE_DATE}</p>

      <div className="mt-8 space-y-8 leading-relaxed text-plume-900">
        <section>
          <h2 className="font-display text-2xl text-plume-950">1. Acceptance</h2>
          <p className="mt-3">
            By using PeacockOmlettes.com (the &ldquo;Site&rdquo;) you agree to these Terms. If you
            do not agree, please close the tab; the omelettes will understand.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-plume-950">2. The Site is humor</h2>
          <p className="mt-3">
            The Site is a satirical humor publication written in the voice of an earnest food blog.
            Its editorial framing, anecdotes, institutional claims, and test-kitchen mythology are
            comedic fiction. The underlying cooking techniques are, however, presented accurately,
            and peafowl eggs are genuinely edible, which brings us to:
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-plume-950">3. Food safety and no advice</h2>
          <ul className="mt-3 list-disc space-y-2 pl-6">
            <li>
              Content on the Site is provided for entertainment and general information only and is
              not professional, nutritional, veterinary, or food-safety advice.
            </li>
            <li>
              If you cook anything: cook eggs of any species fully, handle raw egg with proper
              hygiene, and follow your local food-safety guidance. Source any eggs lawfully and from
              reputable suppliers.
            </li>
            <li>
              You are solely responsible for accounting for allergies, dietary restrictions, and the
              safety of anyone you feed.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-2xl text-plume-950">4. Intellectual property</h2>
          <p className="mt-3">
            All text, illustrations, and design on the Site are the property of the Site operator
            unless otherwise noted. You may share links freely and quote reasonably with
            attribution. Wholesale republication of the collection is not permitted.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-plume-950">5. Advertising</h2>
          <p className="mt-3">
            The Site displays third-party advertising served by Google. Advertisers, not the Site,
            are responsible for their ad content, and an ad&rsquo;s appearance here is not an
            endorsement. Ad processing of personal data is governed by our Privacy Policy and your
            consent choices.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-plume-950">6. No warranty</h2>
          <p className="mt-3">
            The Site is provided &ldquo;as is&rdquo; and &ldquo;as available&rdquo;, without
            warranties of any kind, express or implied, including merchantability, fitness for a
            particular purpose, non-infringement, or uninterrupted availability.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-plume-950">7. Limitation of liability</h2>
          <p className="mt-3">
            To the maximum extent permitted by law, the Site operator is not liable for any
            indirect, incidental, special, consequential, or exemplary damages arising from your use
            of the Site, and total liability for any claim is limited to the amount you paid to use
            the Site, which is zero.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-plume-950">8. Governing law</h2>
          <p className="mt-3">
            These Terms are governed by the laws of the State of California, United States, without
            regard to conflict-of-law principles, and any disputes will be resolved in the courts
            located there.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-plume-950">9. Changes and contact</h2>
          <p className="mt-3">
            We may update these Terms by posting a revised version here with a new effective date.
            Questions go to{' '}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="font-semibold underline underline-offset-4"
            >
              {CONTACT_EMAIL}
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
}
